import { bankFeedApi } from '@/domain/bankFeed/api';
import type { BankFeedAccountType } from '@/domain/bankFeed/schemas';
import { queryOptions } from '@/services/query';
import { bankFeedKeys } from '@/domain/bankFeed/queries/keys';

type Args = {
  field: string;
  accountType: BankFeedAccountType;
  currency: string;
  // Toolbar "Bank and account" filter; empty array = all accounts. Part of the
  // query key so option lists refetch when the account scope narrows.
  accountIds: string[];
};

// Consumed imperatively via `queryClient.fetchQuery` from the set-filter's on-open
// handler (BankFeedSetColumnFilter → BankFeedGrid `loadOptions`). The option list is
// derived by the backend from the current grid transactions, so it must reflect
// freshly-synced/added rows — `staleTime: 0` makes each open refetch instead of
// serving a stale cached list, while concurrent opens of the same key still dedupe.
export const bankFeedTransactionsAutocompleteQuery = ({
  field,
  accountType,
  currency,
  accountIds,
}: Args) =>
  queryOptions({
    queryKey: bankFeedKeys.transactionsAutocomplete(field, accountType, currency, accountIds),
    queryFn: () =>
      bankFeedApi.getTransactionsAutocomplete({
        body: { field, account_type: accountType, account_ids: accountIds, currency },
      }),
    staleTime: 0,
  });
